<template>
	<div>
		<div class="box"></div>
		<div style="position: relative" class="boxTitle">
			<img
				src="../../assets/images/services.png"
				style="width: 1250px; position: absolute; left: 50%; height: 240px; margin-left: -625px"
			/>
		</div>
		<div class="tabList">
			<div
				v-for="(item, index) in tabList"
				:class="check == index ? 'tabColor' : 'tabImg'"
				@click="changItem(index)"
			>
				<img :src="item.imgs" />
			</div>
		</div>
		<div class="tabContents">
			<div class="contentItem wow animate__bounceInRight animate__animated" ref="contentItem">
				<div class="titleImg">
					<img v-show="check == 0" src="../../assets/images/title1.png" alt="" />
					<img v-show="check == 1" src="../../assets/images/wxtitle.png" alt="" />
					<img v-show="check == 2" src="../../assets/images/H5title.png" alt="" />
					<img v-show="check == 3" src="../../assets/images/WEBtitle.png" alt="" />
				</div>
				<div class="appimg" ref="imgBox">
					<img v-if="check == 0" src="../../assets/images/service_phone.png" />
					<img v-if="check == 1" src="../../assets/images/wximg.png" />
					<img v-if="check == 2" src="../../assets/images/H5.png" />
					<img v-if="check == 3" src="../../assets/images/WEB.png" />
				</div>
				<div class="titlebox">
					<p class="p-one">
						<span v-if="check == 0">APP</span>
						<span v-if="check == 1">小程序</span>
						<span v-if="check == 2">H5</span>
						<span v-if="check == 3">网站</span>
						<span>开发</span>
					</p>
					<p class="p-two">
						<span v-if="check == 0">APP</span>
						<span v-if="check == 1">MP</span>
						<span v-if="check == 2">H5</span>
						<span v-if="check == 3">WEB</span>&nbsp;development
					</p>
				</div>
				<div class="titleline">
					<div style="width: 59px; height: 5px; background-color: #12b1f9"></div>
				</div>
				<div class="introduce">
					<p v-if="check == 0">
						我司提供iOS与Android双版本APP的客制化设计服务，配备专业、负责地开发团队为您提供优质方案及一站式开发服务
					</p>
					<p v-if="check == 1">
						用我们丰富的开发经验，让您的品牌传播更广，获客更高效，用户体验更好。
					</p>
					<p v-if="check == 2">我们用创新和创意来吸引用户，提高互动、参与、转发。</p>
					<p v-if="check == 3">
						我们根据客户的功能需求来完成一套规范的开发流程，包括：设计框架、UI设计、开发、测试上线、后期系统运维等专业服务。
					</p>
				</div>
				<div class="footers">注：由于隐私协议关系，具体案例请邮件联系商务进行了解。</div>
			</div>
		</div>
		<RequireMent></RequireMent>
	</div>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from "vue";
const check = ref(0);
const imgBox = ref();
const contentItem = ref();
const show = ref(false);
const tabList = ref([
	{ imgs: require("../../assets/images/service_app.png") },
	{ imgs: require("../../assets/images/service_wx.png") },
	{ imgs: require("../../assets/images/service_h5.png") },
	{ imgs: require("../../assets/images/service_web.png") },
]);
onMounted(() => {
	show.value = true;
	getWidth();
});
window.onresize = () => {
	getWidth();
};
onUnmounted(() => {
	show.value = false;
	window.removeEventListener("resize", onresize);
});
const changItem = (index) => {
	check.value = index;
	getWidth();
};

const getWidth = () => {
	// const imgwidth = imgBox.value.offsetWidth;
	if (show.value) {
		const width = window.innerWidth;
		var a = contentItem.value.offsetWidth;
		var aspectRatio = 0.448;
		var imgb = aspectRatio * a;
		// let b = document.querySelector(".contentItem");
		let titlebox = document.querySelector(".titlebox");
		let titleline = document.querySelector(".titleline");
		let introduce = document.querySelector(".introduce");
		let titleimg = document.querySelectorAll(".titleImg img");
		let tabContents = document.querySelector(".tabContents");
		const abili = 0.446 * a;
		const titleboxbi = 0.155 * a;
		const linebili = 0.28 * a;
		const introducebi = 0.425 * a;
		const titleImgbi = 0.86 * a;
		const titleImgh = 0.099 * a;
		if (width < 575) {
			imgBox.value.style.width = width * 0.9 + "px";
			imgBox.value.style.height = width * 0.9 + "px";
			introduce.style.width = width * 0.9 + "px";
			titleline.style.width = width * 0.5 + "px";
			tabContents.style.height = 1.7 * width + "px";
			contentItem.value.style.height = 1.5 * a + "px";
		} else {
			imgBox.value.style.width = imgb + "px";
			imgBox.value.style.height = imgb + "px";
			introduce.style.width = introducebi + "px";
			titleline.style.width = linebili + "px";
			contentItem.value.style.height = abili + "px";
			tabContents.style.height = 545 + "px";
		}
		titleimg.forEach((img) => {
			img.style.width = titleImgbi + "px";
			img.style.height = titleImgh + "px";
		});
	}
};
</script>
<style lang="less" scoped>
.box {
	height: 80px;
	width: 100%;
}
.boxTitle {
	background-image: url("../../assets/images/bnnderBG.png");
	background-repeat: no-repeat;
	background-size: cover;
	width: 100%;
	height: 240px;
	overflow: hidden;
}
.titleImg {
	position: absolute;
	left: 50px;
	img {
		width: 860px;
		height: 99px;
	}
}
.tabList {
	background: #eef6fa;
	box-shadow: 0px 10px 52px 8px rgba(86, 157, 229, 0.22);
	width: 100%;
	margin-top: -4px;
	height: 100px;
	display: flex;
	// box-sizing: border-box;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	.tabImg {
		// flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		width: 200px;
		cursor: pointer;
		img {
			height: 70px;
		}
	}
	.tabColor {
		display: flex;
		height: 100%;
		align-items: center;
		justify-content: center;
		background-color: rgb(221, 242, 251);
		width: 200px;
		img {
			height: 70px;
		}
	}
}
.tabContents {
	background-image: url("../../assets/images/tabImgbg.png");
	background-repeat: repeat;
	background-position: 50% 50%;
	width: 100%;
	height: 545px;
	display: flex;
	justify-content: center;
	padding-top: 50px;
	// align-items: center;
	.contentItem {
		position: relative;
		padding-top: 20px;
		width: 1000px;
		height: 446px;
		background: #ffffff;
		box-shadow: 0px 12px 48px 8px rgba(148, 201, 255, 0.26);
		// display: flex;
		.appimg {
			position: absolute;
			top: 20px;
			right: 10px;
			width: 448px;
			height: 448px;
			img {
				width: 100%;
				height: 100%;
			}
		}
	}
}
.footers {
	color: #cccccc;
	font-size: 14px;
	position: absolute;
	left: 55px;
	bottom: 50px;
}
.titlebox {
	position: absolute;
	left: 50px;
	top: 47px;
}

.p-one {
	font-size: 38px;
	font-weight: bold;
	color: #1a1a1a;
}
.p-two {
	font-size: 16px;
	color: #cfd7db;
	margin-top: 10px;
}
.titleline {
	width: 280px;
	border-bottom: 1px solid #e2eaee;
	position: absolute;
	left: 52px;
	top: 160px;
}
.introduce {
	font-size: 18px;
	color: rgb(88, 104, 123);
	width: 425px;
	font-weight: bold;
	position: absolute;
	left: 55px;
	top: 200px;
	line-height: 1.75;
	font-family: 等线;
}

@media screen and(min-width:575px) and (max-width: 790px) {
	.titlebox {
		top: 30px;
	}

	.titlebox .p-two {
		margin-top: 0;
	}
	.titlebox .p-two span {
		font-size: 14px;
	}
	.introduce p {
		font-size: 16px;
		line-height: 1.2;
	}
	.contentItem .footers {
		font-size: 10px;
		bottom: 38px;
	}
	.titleline {
		top: 120px;
	}
	.introduce {
		top: 150px;
	}
}
@media screen and(max-width:575px) {
	.titlebox {
		left: 10px;
		top: 30px;
		// width: 100%;
	}
	.titlebox .p-one span {
		font-size: 36px;
	}

	.titleImg {
		left: 10px;
		// img {
		// 	width: 100%;
		// }
	}

	.contentItem .appimg {
		left: 10px;
		top: 100px !important;
		max-width: 448px !important;
		max-height: 448px !important;
		img {
			width: 100%;
			// resize: contain;
		}
	}
	.titleline {
		left: 10px;
		top: 70%;
	}

	.introduce {
		left: 10px;
		// bottom: 300px;
		top: 80%;
	}
	.footers {
		left: 10px;
		top: 75%;
	}
}
@media screen and(max-width:384px) {
	.footers {
		left: 10px;
		top: 75%;
		font-size: 12px;
	}

	.introduce {
		left: 10px;
		top: 80%;
		font-size: 14px;
	}
}
</style>
